export class AppVersion {
   static appVersion = 1;
}